<template>
  <div>
    <DeleteModal
      modalId="modal-consumables-delete"
      @deleteToggle="deleteItem"
    />

    <b-card no-body class="consumables-card">
      <b-card-header class="section-header">
        <div
          class="d-flex justify-content-between align-items-center header-actions-wrapper"
        >
          <h5 class="mb-0">
            <feather-icon icon="PackageIcon" size="18" class="mr-2" />
            {{ $t("surgery.patient-surgery-consumables") }}
          </h5>
          <div>
            <b-button
              variant="primary"
              size="sm"
              class="mr-2"
              @click="
                $router.push({
                  name: 'add-patient-surgery-consumables',
                  params: { id: doctorSurgeryId },
                })
              "
              v-if="
                $store.state.app.permissions.includes(
                  'store-patientCardTest'
                ) && !isHistory
              "
            >
              <feather-icon icon="PlusIcon" size="14" class="mr-1" />
              {{ $t("common.add") }} {{ $t("surgery.consumables") }}
            </b-button>
            <b-button variant="success" size="sm" @click="printConsumables()">
              <feather-icon icon="PrinterIcon" size="14" class="mr-1" />
              {{ $t("common.print") }} {{ $t("surgery.consumables") }}
            </b-button>
          </div>
        </div>
      </b-card-header>
      <b-card-body>
        <div v-if="loading" class="text-center py-4">
          <b-spinner :label="$t('common.loading')" />
        </div>
        <div v-else-if="data && data.length > 0" class="modern-cards-grid">
          <div
            v-for="consumable in data"
            :key="consumable.id"
            class="modern-card"
          >
            <div class="modern-card-header">
              <div class="modern-card-icon">
                <feather-icon
                  icon="PackageIcon"
                  size="24"
                  class="text-success"
                />
              </div>
              <div class="modern-card-title">
                {{ consumable.item ? consumable.item.name : "N/A" }}
              </div>
            </div>
            <div class="modern-card-content">
              <div class="modern-card-info-item">
                <feather-icon icon="HashIcon" size="14" />
                <span
                  >{{ $t("common.quantity") }}: {{ consumable.quantity }}</span
                >
              </div>
              <div class="modern-card-info-item" v-if="consumable.price">
                <feather-icon icon="DollarSignIcon" size="14" />
                <span>{{ consumable.price }} IQD</span>
              </div>
            </div>
            <div class="modern-card-footer" v-if="!isHistory">
              <ActionsButtons
                :noEdit="true"
                deletePerm="delete-patientCardTest"
                editPerm="delete-patientCardTest"
                @editToggle="show(consumable)"
                @deleteToggle="deleteModel(consumable)"
              />
            </div>
          </div>
        </div>
        <div v-else class="no-data-empty">
          <feather-icon icon="PackageIcon" size="48" class="empty-icon" />
          <p>{{ $t("common.no-data-available") }}</p>
        </div>
      </b-card-body>
    </b-card>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="patient card"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="html2PdfMeds"
    >
      <section
        dir="rtl"
        class="pdf-content font-modify m-5 text-dark"
        slot="pdf-content"
      >
        <div dir="rtl" class="container mt-3">
          <div class="container">
            <!-- Row for the first heading -->
            <div class="row">
              <div class="col-12">
                <h4 style="text-align: right">
                  اسم المريض : {{ patientName }}
                </h4>
              </div>
            </div>
            <!-- Row for the second and third headings -->
            <div class="row justify-content-center mt-2">
              <div class="col-auto">
                <h5>صرفيات العملية :</h5>
              </div>
              <div class="col-auto">
                <h5 class="mx-3">رقم الفايل :</h5>
              </div>
            </div>
          </div>

          <table class="border border-0 mt-1">
            <tr>
              <th scope="col">ت</th>
              <th scope="col">المادة</th>
              <th scope="col">العدد</th>
              <th scope="col">السعر</th>
            </tr>
            <tbody>
              <tr v-for="(item, index) in data" :key="index">
                <th scope="row">{{ index + 1 }}</th>
                <td>{{ item.item.name }}</td>
                <td>{{ item.quantity }}</td>
                <td>{{ item.price }}</td>
              </tr>
            </tbody>
          </table>
          <div class="row justify-content-center mt-3">
            <div class="col-auto">
              <h5>الممرضة المسؤولة :</h5>
            </div>
            <div class="col-auto">
              <h5 class="mx-3">مسؤول العمليات :</h5>
            </div>
          </div>
        </div>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import DeleteModal from "@/components/modals/DeleteModal.vue";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import VueHtml2pdf from "vue-html2pdf";

export default {
  components: {
    DeleteModal,
    ActionsButtons,
    BCard,
    BCardHeader,
    BCardBody,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    AutoComplete,
    VueHtml2pdf,
  },

  props: ["patientCardId", "doctorSurgeryId", "patientName"],
  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      data: [],
      EditForm: {
        patient_card_id: "",
        tests: [],
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        patient_card_id: "",
        tests: [],
      },
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        {
          key: "item.name",
          label: this.$t("surgery.consumable"),
          sortable: true,
        },
        {
          key: "quantity",
          label: this.$t("common.quantity"),
          sortable: true,
        },

        // { key: 'price', label: this.$t('common.price'), sortable: true },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
    };
  },
  mounted() {
    this.getPatientSurgeryConsumables();
  },
  methods: {
    printConsumables() {
      this.$refs.html2PdfMeds.generatePdf();
    },
    async getPatientSurgeryConsumables() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/patientSurgeryConsumable?filter[patient_card_surgery_id]=${this.doctorSurgeryId}&include=item&page=${this.page}&take=${this.take}&sort=-id`;

      if (this.testFilter) {
        url += `&filter[test_id]=${this.testFilter}`;
      }
      if (this.patientFilter) {
        url += `&filter[patient_card_id]=${this.patientFilter}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-consumables-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/patientSurgeryConsumable/${this.deleteForm.id}`)
        .then((response) => {
          this.getPatientSurgeryConsumables();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },
  },
};
</script>
<style scoped lang="scss">
.consumables-card {
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.section-header {
  background-color: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  padding: 0.625rem 1rem;
  display: flex;
  align-items: center;

  h5 {
    font-size: 1rem;
    font-weight: 600;
    color: #111827;
    display: flex;
    align-items: center;
    margin-bottom: 0;
  }

  .header-actions-wrapper {
    width: 100%;
    gap: 1rem;
  }
}

// Modern Cards Grid
.modern-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.25rem;
}

.modern-card {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 2px solid #e2e8f0;
  border-radius: 14px;
  padding: 1.25rem;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
}

.modern-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  border-color: #667eea;
}

.modern-card-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.modern-card-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.modern-card-title {
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
  flex: 1;
  line-height: 1.3;
}

.modern-card-content {
  flex: 1;
  margin-bottom: 1rem;
}

.modern-card-info-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #64748b;
  margin-bottom: 0.5rem;

  &:last-child {
    margin-bottom: 0;
  }

  svg {
    flex-shrink: 0;
    color: #94a3b8;
  }
}

.modern-card-footer {
  display: flex;
  align-items: center;
  padding-top: 0.75rem;
  border-top: 1px dashed #cbd5e1;
  gap: 0.5rem;
}

.no-data-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  color: #94a3b8;
}

.no-data-empty .empty-icon {
  opacity: 0.3;
  margin-bottom: 1rem;
}

.no-data-empty p {
  margin: 0;
  font-size: 1rem;
}

.font-modify {
  letter-spacing: normal !important;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
